export default __webpack_public_path__ + "static/media/CriqueGrotesk-Medium.bfca4ff7.woff";